import { render, staticRenderFns } from "./accountBill.vue?vue&type=template&id=9475b2c4"
import script from "./accountBill.vue?vue&type=script&lang=js"
export * from "./accountBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports